export enum ShopperAiIntegrationType {
  Gmail = "gmail",
  Outlook = "outlook",
  Instagram = "instagram",
  Facebook = "facebook",
  Tiktok = "tiktok",
  Attentive = "attentive",
  Postscript = "postscript",
  Redochatai = "redoChatAi",
  Redochatflow = "redoChatFlow",
  Redochatlive = "redoChatLive",
  TelnyxSms = "telnyx_sms",
  TelnyxVoice = "telnyx_voice",
  Mobilemessage = "mobileMessage",
  Contactform = "contactForm",
  SmsPhoneNumber = "sms_phone_number",
  Imessage = "imessage",
  CustomEmail = "custom_email",
  GorgiasSms = "gorgias_sms",
  SharedSms = "shared_sms",
  Rcs = "rcs",
  RichpanelSms = "richpanel_sms",
  Ses = "ses",
  AppleMessages = "apple_messages",
}
